<template>
  <div class="form-group" v-if="fbinvisible != 'true'">
    <!-- <div :class="wrapperclass"> -->
    <div class="row" :style="fblabelposition == 'right'? 'flex-direction: row-reverse;': ''">
      <div
        class="col-form-label"
        :class="fblabelposition == 'top' ? 'col-sm-12' : fblabelposition == 'center' ? 'col-sm-12 text-center' : fblabelposition == null|| undefined || '' ? 'col-sm-12' :'col-sm-2'"
        v-if="fbhidelabel !== 'true'"
      >
        
        <label><b style="color: red;" v-if="fbrequired == 'true'">*</b>{{fbsupportmultiplelanguages? $helper.getWord(fblabel) :fblabel || '&nbsp;' }}</label>
      </div>
      <!-- <div :class="inputclass + 'col-sm-12'" > -->
      <div
        class="col-form-input"
        :class="fblabelposition == 'top'? 'col-sm-12' : fblabelposition == 'center' ? 'col-sm-12' : (fblabelposition == null || undefined || '')? 'col-sm-12' : 'col-sm-10'"
      >
        <input
          :value="value"
          :id="id"
          v-bind:class="className"
          type="text"
          ref="input"
          class="form-control datepicker"
          :required="fbrequired == 'true' ? true : false"
          autocomplete="off"
          :readonly="checkReadonly(isedit, fbreadonly)"
        />
      </div>
      <span v-if="fbhelptext" class="form-text text-muted">{{ fbhelptext }}</span>

      <!-- </div> -->
    </div>
    <!-- </div> -->
  </div>
</template>

<script>
import helper from "@/vueHelper"
export default {
  name: "DateTime",
  props: [
    "id",
    "fbsupportmultiplelanguages",
    "fblabel",
    "fbplaceholder",
    "labelwidth",
    "value",
    "fbvalue",
    "fbrequired",
    "fbreadonly",
    "minDate",
    "maxDate",
    "fbhidelabel",
    "fblabelposition",
    "fbhelptext",
    "className",
    "wrapperclass",
    "labelclass",
    "inputclass",
    "isedit",
    "fbtype",
    "fbinvisible"
  ],
  computed: {
    tracker() {
      return this.$store.getters.getChangeTracker;
    },
    labelCol() {
      return this.labelwidth || 12;
    },
    
  },

  data() {
    return {
      // date: "",
      inited: false,
      isValid: true,
      val: null
    };
  },
  methods: {
    initDatepicker() {
      let $vm = this;
      if (this.isedit) {
        if (this.fbreadonly == "true") {
          if ($(this.$el.daterangepicker)) {
            $(this.$el.daterangepicker).daterangepicker("update");
            $(this.$el.daterangepicker).daterangepicker("remove");
          }
        } else {
          if (jQuery().daterangepicker) {
            if ($(this.$refs.input).length) {
              var self = this;

              let options = { singleDatePicker: true, showDropdowns: true, minYear: 1,  "locale": {"format": "DD/MM/YYYY HH:mm"}, timePicker: true,  timePicker24Hour: true}
              if(this.fbtype == 'pastToNow'){
                options.maxDate =  moment().format("DD/MM/YYYY HH:mm")
              }
              $(this.$refs.input).daterangepicker(options);
            }

            this.$nextTick(() => {
              $(this.$refs.input).on("input", () => {
                this.$emit("input", moment.utc($($this.$refs.input).val(),["DD/MM/YYYY HH:mm",'YYYY-MM-DD HH:mm']).format("DD/MM/YYYY HH:mm"));
              });

              $(this.$refs.input).on("change", () => {
                this.$emit("input", moment.utc($(this.$refs.input).val()).format("DD/MM/YYYY HH:mm"));
              });

              if (this.value != null) {
                $("#" + this.id).val(
                  moment.utc(this.value,["DD/MM/YYYY HH:mm",'YYYY-MM-DD HH:mm']).format("DD/MM/YYYY HH:mm")
                );
              }
            });
          }
        }
      } else {
        if ($(this.$el.daterangepicker)) {
          $(this.$el.daterangepicker).daterangepicker("update");
          $(this.$el.daterangepicker).daterangepicker("remove");
        }
      }
    },
    checkReadonly(isedit, fbreadonly) {
      let readonly = true;
      if (isedit) {
        if (fbreadonly == "true") {
          readonly = true;
        } else {
          readonly = false;
        }
      } else {
        readonly = true;
      }
      return readonly;
    }
  },
  mounted() {
    let $vm = this;
 
    if (this.fbvalue) {
      this.$emit(
        "input",
        moment.utc(this.fbvalue,["DD/MM/YYYY HH:mm",'YYYY-MM-DD HH:mm']).format("DD/MM/YYYY HH:mm"),
        this
      ); //initialize the default value
    }

    if (this.value) {
      let localDatetime = helper.formatDatetime(this.value);
      let val;

      if(localDatetime!="Invalid date"){
        val = localDatetime;
      }else{
        val = this.value;
      }

      this.$emit(
        "input",
        moment.utc(val,["DD/MM/YYYY HH:mm",'YYYY-MM-DD HH:mm']).format("DD/MM/YYYY HH:mm"),
        this
      );
    }

    if (this.value) {
      $(this.$refs.input).val(this.value);
    }

    $(this.$refs.input).focus(() => {
      this.initDatepicker();
    });
  },
  watch: {
    isedit: function() {
      if (this.value != null) {
        this.$emit(
          "input",
          moment.utc(this.value,["DD/MM/YYYY HH:mm",'YYYY-MM-DD HH:mm']).format("DD/MM/YYYY HH:mm"),
          this
        );
      }
      this.initDatepicker();
    }
  },
};
</script>